module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alibabaRegionAutocomplete.noRegionHint":"Please specify the region which you are connecting to."}}')
  delete Component.options._Ctor
}
